<div class="report-container">

  <div class="report-header">
    <h2 class="report-title">Productivity</h2>
  </div>

  <div class="filter-container">

    <mat-radio-group class="grouping-radio-group" [(ngModel)]="groupingPeriod" (change)="loadReport()">
      <mat-radio-button value="month">Month</mat-radio-button>
      <mat-radio-button value="week">Week</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="outline" class="year-field">
      <mat-label>Year</mat-label>
      <mat-select [(ngModel)]="selectedYear" (selectionChange)="loadReport()">
        <mat-option value="all">All</mat-option>
        <mat-option *ngFor="let y of availableYears" [value]="y">{{ y }}</mat-option>
      </mat-select>
    </mat-form-field>

    @if (isSupervisor) {
      <mat-form-field appearance="outline" class="users-field">
        <mat-label>Users</mat-label>
        <mat-select multiple [(ngModel)]="selectedUsers" [compareWith]="compareUsers" (selectionChange)="loadReport()">
          <mat-option *ngFor="let u of users" [value]="u">{{ u.firstName }} {{ u.lastName }}</mat-option>
        </mat-select>
      </mat-form-field>
    }

  </div>

  @if (loading) {
    <div class="loading-row">Loading...</div>
  } @else if (gridRows.length === 0) {
    <div class="empty-row">No activity found for the selected filters.</div>
  } @else {
    <div class="grid-scroll">
      <table class="productivity-grid">
        <thead>
          <tr>
            <th class="date-header-cell">Date</th>
            @for (u of gridUsers; track u.userId) {
              <th class="user-header-cell">{{ u.displayName }}</th>
            }
            @if (gridUsers.length > 1) {
              <th class="user-header-cell total-header-cell">Total</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of gridRows; track row.node.periodKey) {
            <tr [class.grid-row-level-0]="row.level === 0" [class.grid-row-level-1]="row.level === 1">
              <td class="date-cell" [style.paddingLeft.px]="12 + row.level * 20">
                <div class="date-row-inner">
                  @if (row.hasChildren) {
                    <button mat-icon-button class="grid-toggle-btn" (click)="toggleGridRow(row.node)" [attr.aria-label]="'Toggle ' + row.node.label">
                      <mat-icon>{{ isGridRowExpanded(row.node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                    </button>
                  } @else {
                    <span class="grid-toggle-spacer"></span>
                  }
                  <span class="date-label">{{ row.node.label }}</span>
                </div>
              </td>
              @for (u of gridUsers; track u.userId) {
                <td class="stat-cell">
                  @if (getUserStat(row.node, u.userId); as stat) {
                    {{ stat.reported }} <span class="verified-count">({{ stat.verified }})</span>
                  } @else {
                    <span class="no-data">&ndash;</span>
                  }
                </td>
              }
              @if (gridUsers.length > 1) {
                <td class="stat-cell total-cell">
                  {{ row.node.reported }} <span class="verified-count">({{ row.node.verified }})</span>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

</div>
